<template>
  <b-card>
    <form-component :page="generalTermsOfSale" @onSubmit="onSubmit" @fetchByLocale="fetchGeneralTermsOfSale" />
  </b-card>
</template>

<script>
import FormComponent from '@/components/pages/shared/FormComponent';
import NotificationMixin from '@/mixins/NotificationMixin';
import { show, submit } from '@/http/static-pages/general-terms-of-sale';
import { createBasicPageForm } from '@/constants/utils/form';

export default {
  mixins: [NotificationMixin],
  components: {
    FormComponent,
  },

  data() {
    return {
      generalTermsOfSale: {
        lang: '',
        title: '',
        value: '',
        title_image: null,
      },
    };
  },

  methods: {
    fetchGeneralTermsOfSale(lang = 'pl') {
      show(lang)
        .then(async ({ data: { data } }) => {
          if (!data) return;

          this.generalTermsOfSale = data;
        })
        .catch(() => {
          this.showErrorNotification(
            'Problem z pobraniem danych',
            'Wystąpił błąd podczas pobierania danych. Skontaktuj się ze swoim developerem.',
          );
        });
    },
    onSubmit(data) {
      const form = createBasicPageForm(data);

      submit(form)
        .then(() => {
          this.showSuccessNotification('Dane zapisane', 'Strona została zapisana.');
        })
        .catch(() => {
          this.showErrorNotification(
            'Problem z zapisaniem danych',
            'Wystąpił błąd podczas zapisywania danych. Skontaktuj się ze swoim developerem.',
          );
        });
    },
  },
};
</script>
